<!--
 * @Description:
 * @Author: mdb
 * @Date: 2023-04-13 13:53:26
 * @LastEditTime: 2023-04-20 10:19:53
 * @LastEditors: mdb
-->
<template>
  <TemplateManage subdomain="ofbu" :permission="permission" />
</template>

<script setup lang="ts">
import TemplateManage from '@/views/marketing/marketingManage/templateManage/index.vue'

const permission = {
  add: 'ofbu_tpl_add_btn',
  del: 'ofbu_tpl_del_btn',
  edit: 'ofbu_tpl_edit_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuTemplateManage' }
</script>

<style scoped></style>
